import { useEffect } from 'react';
import { BackHandler } from 'react-native';

export const useBackPress = (onBack: () => boolean) => {
  useEffect(() => {
    const backAction = BackHandler.addEventListener('hardwareBackPress', () => {
      return onBack();
    });
    return () => {
      backAction.remove();
    };
  }, [onBack]);
};
